import axios from 'axios';

export const getErrorMessage = (error: unknown, fallback = 'Произошла ошибка'): string => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;

    return data?.error ?? data?.Error ?? data?.detail ?? data?.message ?? fallback;
  }

  if (error instanceof Error) return error.message || fallback;

  return fallback;
};